import { isDefined, isNotDefined } from '@sgme/fp';
import type { CustomCellRendererProps } from 'ag-grid-react';
import type { ReactNode } from 'react';
import { FormattedNumber, FormattedTime } from 'react-intl';

import { StatusBadge } from '@/App/Blotter/grids/StatusBadge.tsx';
import { FormattedFXDate } from '@/components/ui/FormattedFXDate.tsx';
import type { BlotterEntryStatus } from '@/store/blotter/api/types/BlotterEntryStatus.ts';
import type { ISODate, ISODateTime } from '@/types/date.ts';

export const DateRenderer: <T>(props: CustomCellRendererProps<T, ISODateTime | ISODate>) => ReactNode = ({ value }) =>
  isDefined(value) &&
  // such date field value was found on production
  value !== 'null' ? (
    <FormattedFXDate value={value} dateStyle="medium" />
  ) : (
    ''
  );

export const TimeRenderer: <T>(props: CustomCellRendererProps<T, ISODateTime>) => ReactNode = ({ value }) =>
  isDefined(value) &&
  // preventive, analogous abberation found in prod
  value !== 'null' ? (
    <FormattedTime value={value} timeStyle="short" />
  ) : (
    ''
  );

export const RateRenderer: <T>(props: CustomCellRendererProps<T, number>) => ReactNode = ({ value }) =>
  isDefined(value) ? <FormattedNumber value={value} maximumFractionDigits={10} /> : '';

export const AmountRenderer = RateRenderer;
export const PointsRenderer = RateRenderer;

export const StatusCellRenderer: <T>(props: CustomCellRendererProps<T, BlotterEntryStatus>) => ReactNode = ({
  value,
}) => {
  if (isNotDefined(value)) {
    return '';
  }
  return <StatusBadge status={value} />;
};
